<template>
  <div class="add-fair-wrap">
    <h2>Add Fair</h2>
    <div class="select-label">
      <label>Server Name:</label>
      <select v-model.trim="serverId.value">
        <option v-for="server in servers" 
          :value="server.id"
          :key="server.id"
        >{{server.name}}</option>
      </select>
      <span v-for="(error, index) in serverId.errors"
        :key="index"
      >{{error}}</span>
    </div>
    <div class="input-label">
      <label>Site Name:</label>
      <input type="text" v-model.trim="siteName.value">
      <span v-for="(error, index) in siteName.errors"
        :key="index"
      >{{error}}</span>
    </div>
    <div class="input-label">
      <label>Fair Title:</label>
      <input type="text" v-model.trim="fairTitle.value">
      <span v-for="(error, index) in fairTitle.errors"
        :key="index"
      >{{error}}</span>
    </div>
    <div class="validation">
      <label for="validation-input">Admin Validation:</label>
      <input type="checkbox" id="validation-input" v-model="hasValidation">
    </div>
    <div class="input-label">
      <label>Mixpanel Key:</label>
      <input type="text" v-model.trim="mixpanelKey.value">
      <span v-for="(error, index) in mixpanelKey.errors"
        :key="index"
      >{{error}}</span>
    </div>
    <div class="input-label">
      <label>Fair URL:</label>
      <input type="text" v-model.trim="fairUrl.value">
      <span v-for="(error, index) in fairUrl.errors"
        :key="index"
      >{{error}}</span>
    </div>
    <div class="input-label">
      <label>Start Date:</label>
      <input type="text" v-model.trim="startDate.value">
      <span v-for="(error, index) in startDate.errors"
        :key="index"
      >{{error}}</span>
    </div>
    <div class="button-wrap">
      <button @click="addFair">Add Fair</button>
    </div>
  </div>
</template>

<script>
import AdminMixin from '../../../views/admin-pages/adminMixin';
import api from '@/api'
export default {
  mixins: [
    AdminMixin
  ],
  props: {
    servers: Array
  },
  data () {
    return {
      siteName: {value: '', errors: []},
      serverId: {value: '', errors: []},
      fairTitle: {value: '', errors: []},
      mixpanelKey: {value: '', errors: []},
      fairUrl: {value: '', errors: []},
      startDate: {value: '', errors: []},
      hasValidation: false
    }
  },
  methods: {
    async addFair () {
      if (this.hasErrors()) {
        return;
      }

      let params = {
        serverId: this.serverId.value,
        siteName: this.siteName.value,
        adminvalidation: this.hasValidation? 1 : 0,
        fair_title: this.fairTitle.value,
        mixpanel_key: this.mixpanelKey.value,
        startDate: this.startDate.value,
        fair_url: this.fairUrl.value
      }

      let apiObj = {
        api: api.setFair,
        params: params,
        onError: () => this.stopLoading()
      }
      this.startLoading();
        if (await this.apiCall(apiObj)) {
          this.showSuccessMessage("Fair Added.");
        }
      this.stopLoading();
    },
    hasErrors () {
      this.clearErrors();
      let allParamsObj = this.createAllParamsObj();
      let errorCount = 0;
      for (const key in allParamsObj) {
        if (this[key].value.toString().length === 0) {
          this[key].errors.push('Field must not be empty');
          errorCount++;
        }
        if (this[key].value.toString().length > 250) {
          this[key].errors.push('Field contents are too long.');
          errorCount++;
        }
      }

      //Special check
      if (this.fairUrl.value[this.fairUrl.value.length - 1] !== '/') {
        this.fairUrl.errors.push('URL must end with a "/"');
        errorCount++;
      }

      if (errorCount > 0) {
        return true;
      } else {
        return false;
      }
    },
    clearErrors () {
      this.siteName.errors = [];
      this.serverId.errors = [];
      this.fairTitle.errors = [];
      this.mixpanelKey.errors = [];
      this.fairUrl.errors = [];
      this.startDate.errors = [];
    },
    createAllParamsObj () {
      return {
        siteName: {value: '', errors: []},
        serverId: {value: '', errors: []},
        fairTitle: {value: '', errors: []},
        mixpanelKey: {value: '', errors: []},
        fairUrl: {value: '', errors: []},
        startDate: {value: '', errors: []}
      }
    }
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}
h2 {
  text-align: center;
}
.add-fair-wrap {
  background: #FFF;
  position: relative;
  width: 100%;
}
.input-label, .select-label {
  margin: 10px 0;
}
.select-label {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.select-label label {
  margin-right: 20px;
}
.input-label span, .select-label span {
  color: red;
  font-size: 0.8em;
  display: block;
}
.button-wrap {
  display: flex;
  justify-content: center;
  margin: 40px 0 20px 0;
}
.button-wrap button {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  white-space: nowrap;
  outline: none;
  border: none;
  padding: 10px 20px;
  border-radius: 100px;
  font-weight: 600;
  background: var(--button-color-blue);
  color: white;
}
</style>